class AnimatedTipText {
	constructor(element, options = {}) {
		this.element = element;
		this.texts = Array.from(this.element.querySelectorAll('span'))
			.map(span => span.textContent.trim());
		this.element.innerHTML = "";
		this.typingSpeed = options.typingSpeed || 50;
		this.deletingSpeed = options.deletingSpeed || 20;
		this.delay = options.delay || 1500;
		this.index = 0;
		this.charIndex = 0;
		this.isDeleting = false;
		this.timeoutId = null;
		this.element.classList.add("animated-tip-text-active");
	}

	start() {
		this._typeEffect();
	}

	_typeEffect() {
		const currentText = this.texts[this.index];

		if (!this.isDeleting) {
			// Typing forward
			this.element.textContent = currentText.substring(0, this.charIndex + 1);
			this.charIndex++;

			if (this.charIndex === currentText.length) {
				this.isDeleting = true;
				this.timeoutId = setTimeout(() => this._typeEffect(), this.delay);
				return;
			}
		} else {
			// Deleting backwards
			this.element.textContent = currentText.substring(0, this.charIndex - 1);
			this.charIndex--;

			if (this.charIndex === 0) {
				this.isDeleting = false;
				this.index = (this.index + 1) % this.texts.length;
			}
		}

		this.timeoutId = setTimeout(
			() => this._typeEffect(),
			this.isDeleting ? this.deletingSpeed : this.typingSpeed
		);
	}
}

export default AnimatedTipText;